import React, { Component } from "react";    
import {connect} from "react-redux"; 
import { withTranslation } from 'react-i18next';

class Maintain extends Component {

    render() {
			const { t } = this.props;
			return (
				<div className="shop-not-avai text-center">
					{/* <img src={require('../../../assets/img/icons/gochi_logo_print.png')}
							 alt={t('other.This feast button cannot be used because the store is not open')}
							 width="100%"
							 className="image-not-available"
					/> */}

					<div className="text-left fs-14">
						{/* エラーが発生しました。時間をおいてお試しください。 */}
						ただいまシステムに内部の構成変更に伴うメンテナンスのため、一時的にサービスの機能を全て停止しております。大変ご不便をおかけいたしますが、今しばらくお待ちください。<br/>
						<br/>
						<b>【メンテナンス作業予定日時】</b><br/>
						2024年2月21日（水）<b>20:00</b> ~ 2月22日（木）<b>08:00</b><br/>
						※メンテナンス作業が終了次第公開いたします。<br/>
						<br/>
						<b>【お問い合わせ】</b><br/>
						<a 
							className="text-green"
							target="_blank"
							rel="noopener noreferrer"
							href="https://support.gigi.tokyo/contact/contact01/"
						>
							https://support.gigi.tokyo/contact/contact01/
						</a>
					</div>
				</div>
			);
    }
}
const mapStateToProps = state => ({
	...state
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Maintain));

